import { Seraphim } from '@lima/seraphim-core';
import { ESeraphimMode } from './ESeraphimMode';
export function hasPermission(permission, mode) {
    if (mode === void 0) { mode = ESeraphimMode.and; }
    var permissions = Array.isArray(permission) ? permission : [permission];
    if (mode === ESeraphimMode.and) {
        return permissions.every(function (p) { return Seraphim.instance.enforce(p); });
    }
    return permissions.some(function (p) { return Seraphim.instance.enforce(p); });
}
